import React, { Component } from "react";
import { connect } from "react-redux";
import { AvForm, AvField } from "availity-reactstrap-validation";

import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
} from "reactstrap";
import Select from "react-select";
import { getMenus } from "../../../store/Masters/Menus/actions";
import {
  InputChangeValue,
  SelecteChangeValue,
  MenuItemAdd,
  model_open,
  model_close,
} from "../../../store/Masters/MenuItems/actions";

class AddMenuItems extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.ChangeHandeler = this.ChangeHandeler.bind(this);
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }
  componentDidMount() {
    this.props.getMenus();
  }
  ChangeHandeler(e) {
    this.props.InputChangeValue({
      key: e.target.name,
      value: e.target.value,
    });
  }
  handleValidSubmit() {
    var data = this.props.rowdata;

    if (data.menu_id == null) {
      // var errorLoc = "Select Location";
    } else {
      if (data.title == null) {
        // var errorSubLoc = "Enter Location";
      } else {
        if (data.link == null) {
        } else {
          var menuItemdata = {
            id: data.id,
            menu_id: data.menu_id,
            sequence: data.sequence,

            title: data.title,
            link: data.link,
            icon: data.icon,
          };
          this.props.MenuItemAdd(menuItemdata);
        }
      }
    }
  }
  render() {
    var data = this.props.rowdata;
    return (
      <React.Fragment>
        <Modal isOpen={this.props.model} backdrop="static" centered size="lg">
          <ModalHeader toggle={() => this.props.model_close()}>
            ADD Menu Item
          </ModalHeader>
          <AvForm
            className="form-horizontal"
            onValidSubmit={this.handleValidSubmit}
          >
            <ModalBody>
              <Row className="justify-content-center">
                <Col md={10}>
                  <Row className="justify-content-center">
                    <Col md={9}>
                      <FormGroup row>
                        <Col md={4}>
                          <Label
                            htmlFor="Location_id_select"
                            className="col-form-label float-right"
                          >
                            Select Menu
                          </Label>
                        </Col>
                        <Col md={8}>
                          <Select
                            id="Location_id_select"
                            name="Location_id_select"
                            classNamePrefix="select2-selection"
                            isClearable={
                              this.props.rowdata?.MenuLabel ? true : false
                            }
                            options={this.props.MenusList.map(
                              (item, index) => ({
                                label: item.name,
                                value: item.id,
                              })
                            )}
                            value={{
                              label:
                                data.MenuLabel == null
                                  ? "Select Menu"
                                  : data.MenuLabel,
                              value: data.menu_id,
                            }}
                            onChange={(e) => {
                              this.props.SelecteChangeValue({
                                key: "MenuLabel",
                                label: e?.label,
                                key2: "menu_id",
                                value: e?.value,
                              });
                            }}
                          />
                          {/* {data.location_id == null && (
                            <Label className="text-danger m-0">
                              {errorLoc}
                            </Label>
                          )} */}
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Col md={4}>
                          <Label
                            htmlFor="MenuTitle"
                            className="col-form-label float-right"
                          >
                            Menu Item Title
                          </Label>
                        </Col>
                        <Col md={8}>
                          <AvField
                            name="title"
                            type="text"
                            value={data.title}
                            onChange={this.ChangeHandeler}
                            className="form-control"
                            id="MenuTitle"
                            placeholder="Enter Menu Title"
                            errormessage=" Please provide a valid Menu Title"
                            validate={{ required: { value: true } }}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Col md={4}>
                          <Label
                            htmlFor="MenuLink"
                            className="col-form-label float-right"
                          >
                            Menu Item Link
                          </Label>
                        </Col>
                        <Col md={8}>
                          <AvField
                            name="link"
                            type="text"
                            value={data.link}
                            onChange={this.ChangeHandeler}
                            className="form-control"
                            id="MenuLink"
                            placeholder="Enter Menu Link"
                            errormessage=" Please provide a valid Menu Link"
                            validate={{ required: { value: true } }}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Col md={4}>
                          <Label
                            htmlFor="Menusequence"
                            className="col-form-label float-right"
                          >
                            Menu Item Sequence
                          </Label>
                        </Col>
                        <Col md={8}>
                          <AvField
                            name="sequence"
                            type="text"
                            value={data.sequence}
                            onChange={this.ChangeHandeler}
                            className="form-control"
                            id="Menusequence"
                            placeholder="Enter Menu Sequence"
                            errormessage=" Please provide a valid Menu Sequence"
                            validate={{ required: { value: true } }}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Col md={4}>
                          <Label
                            htmlFor="MenuIcon"
                            className="col-form-label float-right"
                          >
                            Menu Item Icon
                          </Label>
                        </Col>
                        <Col md={8}>
                          <AvField
                            name="icon"
                            type="text"
                            value={data.icon}
                            onChange={this.ChangeHandeler}
                            className="form-control"
                            id="MenuIcon"
                            placeholder="Enter Menu Icon"
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup>
                        <AvField
                          className="form-control"
                          type="hidden"
                          value={data.id}
                          id="id"
                          name="id"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <ModalFooter>
                <Button
                  type="button"
                  className="btn btn-danger"
                  color="light"
                  onClick={() => this.props.model_close()}
                >
                  Close
                </Button>
                <Button
                  type="submit"
                  className="btn btn-primary"
                  color="primary"
                >
                  Save
                </Button>
              </ModalFooter>
            </ModalBody>
          </AvForm>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { MenusList } = state.Menus;
  const { Sublocationlist, model, rowdata } = state.MenuItems;
  return { MenusList, Sublocationlist, model, rowdata };
};

export default connect(mapStatetoProps, {
  getMenus,
  InputChangeValue,
  SelecteChangeValue,
  MenuItemAdd,

  model_open,
  model_close,
})(AddMenuItems);
